import React from "react";
import { useTranslation } from "react-i18next";

const SectionHeader = ({
  name = "",
  eventSection = false,
  seniorLayout = false,
}) => {
  const { t } = useTranslation(); 

  return (
    <div className="flex flex-row items-center gap-2 font-semibold py-4 text-danger whitespace-nowrap">
      {eventSection}
      <span className={`text-${seniorLayout ? "2xl" : "[25px]"}`}>
        {t(name)}
      </span>
    </div>
  );
};

export default SectionHeader;
